import { useMutation, UseMutationResult, useQuery, UseQueryResult } from 'react-query';
import type { ResponseFormat } from '../algebra/global';

import { Http } from '../prelude/http';
import type { ISmsFormData } from '../algebra/conversations';

//1. POST /ingress/wechat-sms.optin
interface IOptInSMSRequest {
  messaging_service_key?: string;
  task_sid?: string;
  phone_number: string;
  otp: number;
}
export function useOptInSMSRequest(): UseMutationResult<string, unknown, IOptInSMSRequest, unknown> {
  return useMutation((request: IOptInSMSRequest) => Http.Request<ResponseFormat<string>>('POST', '/hotlines/api/v1/ingress/webchat-sms.optin', {}, request).then((res) => res.data));
}

//2.  Get /ingress/webchat-sms.status
//retries at : 10,30,60,100 seconds
export function useGetWebChatSMSNumberStatus(task_sid: string | undefined, opted: boolean, messaging_service_key: string | undefined): UseQueryResult<boolean> {
  return useQuery(
    ['sms-status', task_sid],
    () => Http.Request<ResponseFormat<boolean>>('GET', `/hotlines/api/v1/ingress/webchat-sms.status?task_sid=${task_sid}&messaging_service_key=${messaging_service_key}`).then((res) => res.data),
    {
      enabled: opted,
      retry: 10,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
    }
  );
}

//3. opt out SMS
interface IOptOutSMSRequest {
  messaging_service_key?: string;
  task_sid?: string;
}
export function useOptOutSMSRequest(): UseMutationResult<string, unknown, IOptOutSMSRequest, unknown> {
  return useMutation(async ({ messaging_service_key, task_sid }) =>
    Http.Request<ResponseFormat<string>>('POST', `/hotlines/api/v1/ingress/webchat-sms.optout?messaging_service_key=${messaging_service_key}&task_sid=${task_sid}`).then((res) => res.data)
  );
}

// 4. send otp
interface IGenerateRequest {
  messaging_service_key?: string;
  task_sid?: string;
  phone_number: string;
  resend_otp?: boolean;
  attempt?: number;
}
export function useGenerateOtpRequest(): UseMutationResult<string, unknown, IGenerateRequest, unknown> {
  return useMutation((request: IGenerateRequest) => Http.Request<ResponseFormat<string>>('POST', '/hotlines/api/v1/ingress/webchat-sms.sendotp', {}, request).then((res) => res.data));
}

export function useSubmitCode(): UseMutationResult<ISmsFormData, unknown, { code: string; link: string }, unknown> {
  return useMutation(async ({ code, link }) =>
    Http.Request<ResponseFormat<ISmsFormData>>('POST', `/hotlines/api/v1/ingress/feedback-form-otp.submit?otp=${code}&link=${link}`).then((res) => res.data)
  );
}
